export const navBarSetCountDownId = (id) => ({type: 'NAV_BAR_SET_COUNT_DOWN_ID', id});
export const navBarCountDownSetStatus = (status) => ({type: 'NAV_BAR_COUNT_DOWN_SET_STATUS', status});
export const navBarSetObjective = (id) => ({type: 'NAV_BAR_SET_OBJECTIVE', id});
export const navBarSetEndCondition = (endCondition) => ({type: 'NAV_BAR_SET_END_CONDITION', endCondition});